import { DatePipe } from '@angular/common';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {environment} from 'src/environments/environment';
import { IFiltroGuaritaLista } from '../faturamento-guarita/filtro/filtro-lista-faturamento-guarita';
import { IFiltroGuaritaListaNotas } from '../faturamento-guarita/filtro/filtro-lista-notas-faturamento-guarita';
import { ControleLogisticoDtoList, FiltroControleLogistico, FiltroPedidoCliente, NotaDtoList, PedidoDto, PedidoDtoList, PedidoGuaritaDto, PedidoGuaritaDtoList, ProgPedidoDto, ProgPedidoDtoList, StatusFaturamento } from '../interface/pedido';
import { IFiltroPedidoLista } from '../pedido-venda/filtro/filtro-lista-faturamento-guarita';
import { UtilService } from 'src/app/service/util';
import { IFiltroSaidasFazendas, SaidasRelatoriosLista } from '../interface/saidas-fazendas';
import { IFiltroPedidosBloqueadosLista } from '../pedido-venda/filtro/filtro-lista-pedidos-bloqueados';
import { IFiltroProgPedidoLista } from '../pedido-venda/filtro/filtro-lista-programacao-pedido';
import { TransferenciaPedidoParaPedidoFiltro } from 'src/app/estoque/romaneio/interface/romaneio';

@Injectable({
  providedIn: 'root'
})
export class PedidoService {
  url = `${environment.urlApiProtheus}/wsrpedido`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService
  ) { }

  listaPedidos(filtro: IFiltroPedidoLista): Observable<PedidoDtoList> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<PedidoDtoList>(`${this.url}/lista`, httpOptions);
  }

  listaPedidosBloqueadosPorRegra(filtro: IFiltroPedidosBloqueadosLista): Observable<PedidoDtoList> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<PedidoDtoList>(`${this.url}/lista-bloqueados`, httpOptions);
  }

  postPedido(pedido: PedidoDto): Observable<PedidoDto> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.post<PedidoDto>(`${this.url}`, pedido, httpOptions);
  }

  getPedido(CC5NUM: string): Observable<PedidoDto> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.get<PedidoDto>(`${this.url}/${CC5NUM}`, httpOptions);
  }

  deletarPedido(CC5NUM: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.delete<any>(`${this.url}/${CC5NUM}`, httpOptions);
  }

  listaPedidosGuarita(CGUARITA: string, filtro: IFiltroGuaritaLista): Observable<PedidoGuaritaDtoList> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<PedidoGuaritaDtoList>(`${this.url}/guarita/lista/${CGUARITA}`, httpOptions);
  }

  getPedidoGuarita(CC5NUM: string): Observable<PedidoGuaritaDto> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.get<PedidoGuaritaDto>(`${this.url}/guarita/${CC5NUM}`, httpOptions);
  }

  postLiberaPedido(pedido: PedidoGuaritaDto): Observable<StatusFaturamento> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.post<StatusFaturamento>(`${this.url}/guarita/libera`, pedido, httpOptions);
  }

  postLiberaPedidoRegra(CC5NUM: string): Observable<StatusFaturamento> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.post<StatusFaturamento>(`${this.url}/desbloqueio/${CC5NUM}`, {}, httpOptions);
  }

  postLiberaPedidoRegraSemValid(CC5NUM: string): Observable<StatusFaturamento> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.post<StatusFaturamento>(`${this.url}/desbloqueio-sem-valid/${CC5NUM}`, {}, httpOptions);
  }

  statusFaturamento(NREGSC9: number): Observable<StatusFaturamento> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.get<StatusFaturamento>(`${this.url}/status-faturamento/${NREGSC9}`, httpOptions);
  }

  listaNotas(CGUARITA: string, filtro: IFiltroGuaritaListaNotas): Observable<NotaDtoList> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<NotaDtoList>(`${this.url}/guarita/notas/${CGUARITA}`, httpOptions);
  }

  eliminarResiduoPedido(CC5NUM: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.post<any>(`${this.url}/residuo/${CC5NUM}`, httpOptions);
  }

  cancelarNF(NREGSF2: number): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.delete<any>(`${this.url}/nota-fiscal/cancelar/${NREGSF2}`, httpOptions);
  }

  statusCancelamento(CF2DOC: string, CF2SERIE: string, CF2CLIENTE: string, CF2LOJA: string): Observable<StatusFaturamento> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.get<StatusFaturamento>(`${this.url}/status-cancelamento/${CF2DOC}/${CF2SERIE}/${CF2CLIENTE}/${CF2LOJA}`, httpOptions);
  }

  getClientePedido(filtro: FiltroPedidoCliente): Observable<PedidoDto> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<PedidoDto>(`${this.url}/cliente`, httpOptions);
  }

  getSaidasFazendasLista(filtro: IFiltroSaidasFazendas): Observable<SaidasRelatoriosLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<SaidasRelatoriosLista>(`${this.url}/relatorio/saidasfazendas`, httpOptions);
  }

  listaProgPedidos(filtro: IFiltroProgPedidoLista): Observable<ProgPedidoDtoList> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<ProgPedidoDtoList>(`${this.url}/programacao/lista`, httpOptions);
  }

  postProgPedido(pedido: ProgPedidoDto): Observable<ProgPedidoDto> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.post<ProgPedidoDto>(`${this.url}/programacao`, pedido, httpOptions);
  }

  getControleLogistico(filtro: FiltroControleLogistico): Observable<ControleLogisticoDtoList> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<ControleLogisticoDtoList>(`${this.url}/controle-logistica/lista`, httpOptions);
  }

  getCodigoPedido(filtro: TransferenciaPedidoParaPedidoFiltro): Observable<PedidoDto> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<PedidoDto>(`${this.url}/codigo`, httpOptions);
  }

}
